import { combineLatest, map, Observable } from 'rxjs'

/**
 * Emits true if any of the provided observables complete with a truthy value.
 * Completes after all sources complete.
 */
export function someJoin<T>(sources: Observable<T>[]): Observable<boolean> {
  return combineLatest(sources).pipe(map(values => values.some(Boolean)))
}
